import SimulatedAccountLendingInterestSettings from "@/models/Accounts/LendingAccounts/Ledgers/Settings/LendingInterest/SimulatedAccountLendingInterestSettings";

export default class SimulatedLendingAccountSettings {
    lendingInterestSettings: SimulatedAccountLendingInterestSettings = new SimulatedAccountLendingInterestSettings();
}